import GiftCardInfo from './GiftCardInfo';

export default GiftCardInfo;
